import { FC, useEffect } from 'react'
import BroadcastsOverview from 'component/Broadcasts/BroadcastsStats/BroadcastsOverview'
import { Col, Row } from 'antd'
import BroadcastMetrics from 'component/Broadcasts/BroadcastsStats/BroadcastMetrics'
import BroadcastSuccessMetrics from 'component/Broadcasts/BroadcastsStats/BroadcastSuccessMetrics'
import { useAppDispatch } from 'hooks/reduxHooks'
import {
	getBroadcastsInsightsAction,
	getBroadcastViewsAction,
} from 'slices/broadcasts'

interface PropTypes {
	clientId?: string
}

const BroadcastsStats: FC<PropTypes> = ({ clientId }) => {
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(
			getBroadcastsInsightsAction({
				client: clientId,
			})
		)
		dispatch(getBroadcastViewsAction(clientId))
	}, [])

	return (
		<Row gutter={[24, 24]}>
			<Col span={14}>
				<BroadcastsOverview />
			</Col>
			<Col span={10}>
				<BroadcastMetrics />
			</Col>
			<Col span={24}>
				<BroadcastSuccessMetrics />
			</Col>
		</Row>
	)
}

BroadcastsStats.defaultProps = {
	clientId: undefined,
}

export default BroadcastsStats
